const Prelaunch = () => {
  return (
    <div className="prelaunch">
      <div className="prelaunch__container">
        <div className="prelaunch__content">
          <h1 className="prelaunch__title">Coming Soon</h1>
          <p className="prelaunch__text">
            We are working hard to launch Stubminer '25. Stay tuned for updates.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Prelaunch;
